module.exports = __webpack_public_path__ + "static/media/20260331_video_search.63dbb5a6.mp4";